export default function extractBounds({ cameras }) {
  const bounds = new google.maps.LatLngBounds()

  for (const camera of cameras) {
    // eslint-disable-next-line no-unused-vars
    for (let [key, value] of Object.entries(camera.markers)) {
      if (key === 'polygon' ||
          key === 'circle' ||
          key === 'ppfHoverPreviewOverlay' ||
          key === 'irPreviewLine' ||
          key === 'PTZcircle' ||
          key === 'cameraView' ||
          key ===  'analyticZones' ||
          key === 'clippedView') continue
      if (camera.horizontalAngleOfView === 180 && (key === 'leftAngle' || key === 'rightAngle')) continue
      bounds.extend(value.getPosition())
    }

    if (camera.horizontalAngleOfView >= 180 && camera.horizontalAngleOfView < 360) {
      const pathArray = camera.markers.polygon.getPath().getArray()
      bounds.extend(pathArray[0])
      bounds.extend(pathArray[180])
    }

    if (camera.horizontalAngleOfView === 360) {
      const circleBounds = camera.markers.circle.getBounds()
      bounds.extend(circleBounds.getNorthEast())
      bounds.extend(circleBounds.getSouthWest())
    }
  }
  return bounds
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/extractBounds.js